import { useRef, useEffect } from "react";
import PropTypes from "prop-types";

import { strCode } from "../../../../../../../../consts";
import { t } from "../../../../../../../../services";
import { useLoadImage } from "../../../../../../../../hooks";

import {
  FlexContainers,
  Paragraph2,
  SmallButton,
  WrapperContainer
} from "../../../../../../../../components";
import { Title } from "../../styled";
import { ButtonWrapper, ContentWrapper, ImageWrapper, TextWrapper, VideoWrapper } from "./styled";

export const WalkthroughSection = ({ title, description, media, isVideo, isActive, onNext }) => {
  const { imageSrc, loadImage } = useLoadImage(media);

  const vidRef = useRef(null);
  const handlePlayVideo = () => {
    if (vidRef?.current) {
      vidRef.current?.play();
    }
  };

  const handleResetVideo = () => {
    if (vidRef?.current) {
      vidRef.current?.pause();
      vidRef.current.currentTime = 0;
      vidRef.current?.load();
    }
  };

  useEffect(() => {
    loadImage();
  }, [loadImage]);

  useEffect(() => {
    if (isActive && isVideo) {
      handlePlayVideo();
    }

    return () => {
      handleResetVideo();
    };
  }, [isActive, isVideo]);

  return (
    <WrapperContainer Container={FlexContainers.FlexColumnBetween} gap={24}>
      <ContentWrapper Container={FlexContainers.FlexColumnStart} gap={24}>
        {isVideo ? (
          <VideoWrapper Container={FlexContainers.FlexColumnStart}>
            <video ref={vidRef}>
              <source src={imageSrc} type={media?.type ?? "video/mp4"} />
            </video>
          </VideoWrapper>
        ) : (
          <ImageWrapper Container={FlexContainers.FlexColumnStart}>
            <img src={imageSrc} alt="icon" />
          </ImageWrapper>
        )}

        <TextWrapper Container={FlexContainers.FlexColumnStart} gap={4}>
          <Title>{title}</Title>
          <Paragraph2>{description}</Paragraph2>
        </TextWrapper>
      </ContentWrapper>

      {onNext && (
        <ButtonWrapper>
          <SmallButton onClick={onNext}>{t(strCode.NEXT_BTN)}</SmallButton>
        </ButtonWrapper>
      )}
    </WrapperContainer>
  );
};

WalkthroughSection.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  media: PropTypes.oneOfType([PropTypes.object, PropTypes.node]).isRequired,
  isVideo: PropTypes.bool.isRequired,
  isActive: PropTypes.bool.isRequired,
  onNext: PropTypes.func
};
